import axios from 'axios'

export const giftlistApi = {

    search({ search, date } = {}) {
        return axios
            .get('/api/v1/giftlist/search?search=' + search + '&date=' + date)
            .then((response) => {
                return response.data
            })
    },

    getGiftlistByUrl({ url } = {}) {
        return axios
            .get('/api/v1/giftlist/getByUrl?url=' + url)
            .then((response) => {
                return response.data
            })
    },

    checkIfUrlIsAvailable({ url } = {}) {
        return axios
            .get('/api/v1/giftlist/UrlIsAvailable?url=' + url)
            .then((response) => {
                return response.data
            })
    },

    getGiftlistByUrlToEdit({ url } = {}) {
        return axios
            .get('/api/v1/giftlist/getByUrlToEdit?url=' + url)
            .then((response) => {
                return response.data
            })
    },

    getProducts({ giftlistId } = {}) {
        return axios
            .get('/api/v1/giftlist/getProducts?giftlistId=' + giftlistId)
            .then((response) => {
                return response.data
            })
    },

    getProductsPaged({ giftlistId, page } = {}) {
        return axios
            .get('/api/v1/giftlist/getProductsPaged?giftlistId=' + giftlistId + '&page=' + page)
            .then((response) => {
                return response.data
            })
    },
    
    getProductsPagedOrdered({ giftlistId, page, order } = {}) {
        return axios
            .get('/api/v1/giftlist/GetProductsPagedOrdered?giftlistId=' + giftlistId + '&page=' + page + '&order=' + order)
            .then((response) => {
                return response.data
            })
    },

    getMyGiftlists({ } = {}) {
        return axios
            .get('/api/v1/giftlist/getmygiftlists')
            .then((response) => {
                return response.data
            })
    },

    createGiftlist({
        contact1_firstName,
        contact1_lastName,
        contact1_email,
        contact1_phone,
        contact1_document,
        contact2_firstName,
        contact2_lastName,
        contact2_email,
        contact2_phone,
        contact2_document,
        eventType,
        eventDate,
        eventPlace,
        eventCity,
        eventState,
        address_street,
        address_city,
        address_state,
        address_country,
        address_zipcode,
        address_neighborhood,
        address_number,
        address_complement,
        url
    } = {}) {
        return axios
            .post('/api/v1/giftlist', {
                contact1_firstName,
                contact1_lastName,
                contact1_email,
                contact1_phone,
                contact1_document,
                contact2_firstName,
                contact2_lastName,
                contact2_email,
                contact2_phone,
                contact2_document,
                eventType,
                eventDate,
                eventPlace,
                eventCity,
                eventState,
                address_street,
                address_city,
                address_state,
                address_country,
                address_zipcode,
                address_neighborhood,
                address_number,
                address_complement,
                url
                    }, {})
            .then((response) => {
                return response.data
            })
    },

    updateGiftlist({
        giftlistId,
        contact1_firstName,
        contact1_lastName,
        contact1_email,
        contact1_phone,
        contact1_document,
        contact2_firstName,
        contact2_lastName,
        contact2_email,
        contact2_phone,
        contact2_document,
        eventType,
        eventDate,
        eventPlace,
        eventCity,
        eventState,
        address_street,
        address_city,
        address_state,
        address_country,
        address_zipcode,
        address_neighborhood,
        address_number,
        address_complement,
		salesman
    } = {}) {
        return axios
            .put('/api/v1/giftlist', {
                giftlistId,
                contact1_firstName,
                contact1_lastName,
                contact1_email,
                contact1_phone,
                contact1_document,
                contact2_firstName,
                contact2_lastName,
                contact2_email,
                contact2_phone,
                contact2_document,
                eventType,
                eventDate,
                eventPlace,
                eventCity,
                eventState,
                address_street,
                address_city,
                address_state,
                address_country,
                address_zipcode,
                address_neighborhood,
                address_number,
                address_complement,
				salesman
                    }, {})
            .then((response) => {
                return response.data
            })
    },

    addProductOrUpdate({ giftlistId, skuId, quantity } = {}) {
        return axios
            .post('/api/v1/giftlist/AddProduct', { giftlistId, skuId, quantity }, {})
            .then((response) => {
                return response.data
            })
    },

    incrementProduct({ giftlistId, skuId } = {}) {
        return axios
            .post('/api/v1/giftlist/IncrementProduct', { giftlistId, skuId, quantity:1 }, {})
            .then((response) => {
                return response.data
            })
    },

    deleteGiftlist({ id } = {}) {
        return axios
            .delete('/api/v1/giftlist/deletegiftlist?id=' + id)
            .then((response) => {
                return response.data
            })
    },

    deleteProduct({ giftlistId, skuId } = {}) {
        return axios
            .delete('/api/v1/giftlist/deleteproduct?giftlistId=' + giftlistId + '&skuId='+ skuId)
            .then((response) => {
                return response.data
            })
    },

    createUrlSuggestion({ Contact1_FirstName, Contact1_LastName, Contact2_FirstName, Contact2_LastName, EventType } = {}) {
        return axios
            .post('/api/v1/giftlist/CreateUrlSuggestion', { Contact1_FirstName, Contact1_LastName, Contact2_FirstName, Contact2_LastName, EventType }, {})
            .then((response) => {
                return response.data
            })
    },

    uploadImage({ giftlistId, file } = {}) {
        const formData = new FormData();
        formData.append('file', file);
        const headers = { 'Content-Type': 'multipart/form-data' };
        return axios
            .post('/api/v1/giftlist/UploadGiftlistImage?giftlistId=' + giftlistId, formData, { headers })
            .then((response) => {
                return response.data
            })
    },    

}
